import React from 'react';

const Footer = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#050505] border-t border-white/10 py-12" data-testid="footer-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 bg-red-700 flex items-center justify-center">
                <span className="text-white font-bold text-sm font-heading tracking-wider">UVD</span>
              </div>
              <div>
                <h3 className="text-lg font-heading uppercase tracking-wide text-white">UVD Media</h3>
                <p className="text-[10px] text-gray-600 uppercase tracking-[0.2em]">Cinematic Book Trailers</p>
              </div>
            </div>
            <p className="text-gray-500 text-sm leading-relaxed mb-4 max-w-md">
              Cinematic book trailers for thriller authors. We turn your novel into a trailer that feels like a real film.
            </p>
            <p className="text-gray-700 text-xs">
              Founded by Coach Dooley, a working author and visual storyteller.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-gray-400 mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {[
                { label: 'Services', id: 'promo-services' },
                { label: 'Our Work', id: 'our-work' },
                { label: 'About', id: 'about' },
                { label: 'FAQ', id: 'faq' }
              ].map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollToSection(link.id)}
                    className="text-gray-500 hover:text-white transition-colors duration-200 text-sm"
                    data-testid={`footer-link-${link.id}`}
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-gray-400 mb-4">Get Started</h4>
            <button
              onClick={() => scrollToSection('contact')}
              className="w-full bg-red-700 hover:bg-red-800 text-white text-sm font-bold uppercase tracking-[0.1em] px-6 py-3 mb-4 transition-colors duration-200"
              data-testid="footer-cta"
            >
              Book Free Consult
            </button>
            <p className="text-gray-600 text-xs">
              Ready to turn your thriller into a cinematic trailer? Let's talk.
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/5">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-700 text-xs">
              &copy; {currentYear} UVD Media. All rights reserved.
            </p>
            <div className="flex items-center space-x-6">
              <a href="#" className="text-gray-600 hover:text-gray-400 transition-colors duration-200 text-xs">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-600 hover:text-gray-400 transition-colors duration-200 text-xs">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
